var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	1568: {
		fallback: () => (__webpack_require__.e(8).then(() => (() => (__webpack_require__(9008))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	1594: {
		fallback: () => (Promise.all([__webpack_require__.e(918), __webpack_require__.e(163), __webpack_require__.e(460)]).then(() => (() => (__webpack_require__(1163))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",

	},
	8371: {
		fallback: () => (Promise.all([__webpack_require__.e(918), __webpack_require__.e(664)]).then(() => (() => (__webpack_require__(1664))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",

	},
	9094: {
		fallback: () => (Promise.all([__webpack_require__.e(460), __webpack_require__.e(298)]).then(() => (() => (__webpack_require__(4298))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",

	},
	4977: {
		fallback: () => (Promise.all([__webpack_require__.e(675), __webpack_require__.e(460)]).then(() => (() => (__webpack_require__(5675))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",

	},
	8477: {
		fallback: () => (__webpack_require__.e(152).then(() => (() => (__webpack_require__(8860))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	8081: {
		fallback: () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(5893))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	8142: {
		fallback: () => (() => (__webpack_require__(7294))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.3",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	2491: {
		fallback: () => (__webpack_require__.e(621).then(() => (() => (__webpack_require__(2621))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	9739: {
		fallback: () => (__webpack_require__.e(543).then(() => (() => (__webpack_require__(2543))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	8738: {
		fallback: () => (() => (__webpack_require__(8711))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.14.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/cache",

	},
	4350: {
		fallback: () => (() => (__webpack_require__(4435))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.14.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	7002: {
		fallback: () => (() => (__webpack_require__(1068))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.4.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/is-prop-valid",

	},
	8813: {
		fallback: () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(745))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	3460: {
		fallback: () => (() => (__webpack_require__(3935))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.3",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	2227: {
		fallback: () => (__webpack_require__.e(152).then(() => (() => (__webpack_require__(8860))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.1.9",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	400: {
		fallback: () => (__webpack_require__.e(8).then(() => (() => (__webpack_require__(9008))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.1.9",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	3184: {
		fallback: () => (__webpack_require__.e(664).then(() => (() => (__webpack_require__(1664))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.1.9",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",

	},
	6168: {
		fallback: () => (__webpack_require__.e(334).then(() => (() => (__webpack_require__(4298))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.1.9",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",

	},
	6709: {
		fallback: () => (() => (__webpack_require__(6601))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.14.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/styled",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [1568,1594,8371,9094,4977,8477,8081,8142,2491,9739,8738,4350,7002,8081,8142,8813,3460,8738,4350,7002,1594,2227];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"137": [
		1568,
		1594,
		8371,
		9094,
		4977,
		8477,
		8081,
		8142,
		2491,
		9739,
		8738,
		4350,
		7002
	],
	"179": [
		8081,
		8142,
		8813,
		3460,
		8738,
		4350,
		7002
	],
	"227": [
		2227
	],
	"460": [
		3460
	],
	"635": [
		400,
		3184,
		6168,
		6709
	],
	"888": [
		1594
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}